import React, { useEffect } from 'react'
import { useParams, Link, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from "react-redux";
import logo from "../../../images/logoebench.png";
import logo1 from "../../../images/googleplaylogo.png";
import logo2 from "../../../images/applogo.png";
import { ToastContainer } from 'react-toastify';
import { JobDescriptionAll, UpdateAccept, UpdateReject } from "./../../../Redux/action/JobDescriptionAction";
import RejectJob from './RejectJob';
import 'react-toastify/dist/ReactToastify.css';
import TableHeader from '../../Common/TableHeader';

const JobDescription = () => {
    const { userResult } = useSelector((state) => state.Auth);
    const userInfo = useSelector((state) => state.JobDescription.result);
    const candidateId = userResult?.userid;;

    const { id } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        dispatch(JobDescriptionAll(id));
    }, []);

    const handleClickAccept = (appliedJobsId) => {
        const data = {
            appliedJobsId,
            jobAcceptanceStatus:"ACCEPTED",
        }
        dispatch(UpdateAccept(data))
    }

    return (
        <>
            <div>
                <ToastContainer />
                <div className=''>
                    <div className=''>
                        {/* <div className='jobdes-thirddiv'>

                            <button
                                onClick={() => navigate(-1)}
                                className="jobdes-back"
                            >
                                <MdKeyboardBackspace />
                            </button>
                            <h2 className='jobdes-heading'>Job Descriptions</h2>
                        </div> */}
                        <TableHeader heading={'Job Descriptions'} />
                    </div>
                    <div className='jobdes-detailmain'>
                        <div className='jobdes-secdet'>
                            <div className='jobdes-role'><p>Looking For Immediate {userInfo.role}</p>
                                <div style={{ display: "flex" }}>
                                    <p className='jobdes-p'>Role:</p>
                                    <p className='jobdes-data'>{userInfo.role}</p>
                                </div>
                                <div style={{ display: "flex" }}>
                                    <p className='jobdes-p'>Location:</p>
                                    <p className='jobdes-data'>{userInfo.jobLocation}</p>
                                </div>
                                <div style={{ display: "flex" }}>
                                    <p className='jobdes-p'>Experience:</p>
                                    <p className='jobdes-data'> {userInfo.requiredExperience}</p>
                                </div>
                                <div >
                                    <p className='jobdes-p1'>Job Description :</p>
                                    <br />
                                    <p className='jobdes-data'>{userInfo.jobDescription}</p>
                                </div>
                                <div style={{ display: "flex" }}>
                                    <p className='jobdes-p'>About Company:</p>
                                    <p className='jobdes-data'>{userInfo.aboutCompany}</p>
                                </div>
                                <div style={{ paddingLeft: "15px" }}>
                                    <button className='jobdes-accept ' onClick={() => handleClickAccept(userInfo.appliedJobsId)} >Accept</button>
                                    <button className='jobdes-accept jobdes-reject'><RejectJob appliedJobsId={userInfo.appliedJobsId} /></button>
                                </div>
                            </div>
                            <div className='jobdes-postedby'><p>Posted By</p>
                                <div style={{ display: "flex" }}>
                                    {/* <div className='jobdes-'><p></p></div> */}
                                    <div className='jobdes-g'>
                                        <p className='jobdes-e'>eBench</p>
                                        <p style={{ marginBottom: "-6px" }}>HR Executive at eBench</p>
                                        <p>Last Login : 18 jan 2022</p>
                                    </div>
                                </div>
                                <div className='jobdes-info'>
                                    <div>
                                        <p>{userInfo.jobView}</p>
                                        <p>Job View</p>
                                    </div>
                                    <div>
                                        <p>50</p>
                                        <p>Applications</p>
                                    </div>
                                    <div>
                                        <p>970007</p>
                                        <p>Job Code</p>
                                    </div>
                                </div>
                                <div>
                                    <p>Posted in</p>
                                    <p>{userInfo.jobTitle}</p>
                                    <hr className='jobdes-hr' />
                                    <p>Recruiter Actions</p>
                                    <p>45</p>
                                </div>
                                <div className='jobdes-gap'></div>
                                <div className='jobdes-appdetail'>
                                    <div className='jobdes-logo'><img src={logo} alt="logo" /></div>
                                    <div style={{ width: "100%" }}>
                                        <p style={{ fontWeight: "bold" }}>Get The eBench App</p>
                                        <p>We will send you a link you download the app in your phone. </p>
                                    </div>
                                </div>
                                <div className='jobdes-detData'>
                                    <div className='jobdes-logo1'><img src={logo1} alt="" className='jobdes-b' /></div>
                                    <div className='jobdes-logo2'><img src={logo2} alt="" className='jobdes-b' /></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default JobDescription